'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');let

SharedWidthSourceDirective=function(_BaseControllerBacked){_inherits(SharedWidthSourceDirective,_BaseControllerBacked);function SharedWidthSourceDirective(){_classCallCheck(this,SharedWidthSourceDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(SharedWidthSourceDirective,[{key:'restrict',get:function()
{
return'A';
}},{key:'textBindings',get:function()
{
return['name'];
}},{key:'controller',get:function()
{
return SharedWidthSourceDirectiveController;
}}]);return SharedWidthSourceDirective}(BaseControllerBackedDirective);let


SharedWidthSourceDirectiveController=function(_BaseResizableDirecti){_inherits(SharedWidthSourceDirectiveController,_BaseResizableDirecti);_createClass(SharedWidthSourceDirectiveController,null,[{key:'$inject',get:function()
{
return['$rootScope','$scope','$element','$window'];
}}]);

function SharedWidthSourceDirectiveController($rootScope,$scope,$element,$window){_classCallCheck(this,SharedWidthSourceDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));

_this2._$rootScope=$rootScope;

_this2._initializeSharedWidths();
_this2._mySharedWidth=null;

$scope.$on('$destroy',function(){
_this2._removeMySharedWidth();
});return _this2;
}SharedWidthSourceDirectiveController.prototype.

_initializeSharedWidths=function _initializeSharedWidths(){
if(!_.exists(this._$rootScope.sharedWidths)){
this._$rootScope.sharedWidths={};
}
};SharedWidthSourceDirectiveController.prototype.









_removeMySharedWidth=function _removeMySharedWidth(){
delete this._$rootScope.sharedWidths[this.name];
};SharedWidthSourceDirectiveController.prototype.

_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){
if(_.exists(newDimensions)&&newDimensions.width!==this._mySharedWidth){
this._mySharedWidth=newDimensions.width;
}
};_createClass(SharedWidthSourceDirectiveController,[{key:'_mySharedWidth',set:function(value){this._$rootScope.sharedWidths[this.name]=value},get:function(){return this._$rootScope.sharedWidths[this.name]}}]);return SharedWidthSourceDirectiveController}(BaseResizableDirectiveController);


module.exports=SharedWidthSourceDirective;
//# sourceMappingURL=sharedWidthSourceDirective.js.map
